<template>
<div id="modals">
  <section class="popup popup-order is-active" v-if="requestModal === 2">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__popup-order">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" @click="$root.requestModal = 0"></button>
            <div class="content-wrapper">
              <div class="choose__box content-box" style="display:block;">
                <div class="nice-select date" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{time}}</span></div>
                <div class="nice-select subject" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{text}}</span></div>
              </div>
              <form action="/">
                <div class="form-wrapper">
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Ваше имя"  v-model="name" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Город" v-model="city"/>
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="+7" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <div class="form__promo">
                    <input autocomplete="off" type="text" name="form[]" class="input input-promo" placeholder="Промо-код" v-model="promo" />
                  </div>
                  <div class="form__btn-wrapper">
                    <button class="form__btn" @click="sendReg">Записаться</button>
                    <span>Все данные защищены</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="popup popup-order is-active" v-if="requestModal === 3">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__popup-order">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" @click="$root.requestModal = 0"></button>
            <div class="content-wrapper">
              <div class="choose__box content-box" style="display:block;">
                <div class="nice-select date" v-if="time" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{time}}</span></div>
                <div class="nice-select subject" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{text}}</span></div>
              </div>
              <form action="/">
                <div class="form-wrapper">
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Ваше имя"  v-model="name" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Город" v-model="city"/>
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="+7" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <div class="form__promo">
                    <input autocomplete="off" type="text" name="form[]" class="input input-promo" placeholder="Промо-код" v-model="promo" />
                  </div>
                  <div class="form__btn-wrapper">
                    <button class="form__btn" @click="sendRegOA">Записаться</button>
                    <span>Все данные защищены</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="popup popup-order is-active" v-if="requestModal === 33">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__popup-order">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" @click="$root.requestModal = 0"></button>
            <div class="content-wrapper">
              <div class="choose__box content-box" style="display:block;">
                <div class="nice-select date" v-if="time" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{time}}</span></div>
                <div class="nice-select subject" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{text}}</span></div>
              </div>
              <form action="/">
                <div class="form-wrapper">
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Ваше имя"  v-model="name" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Город" v-model="city"/>
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="+7" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <div class="form__promo">
                    <input autocomplete="off" type="text" name="form[]" class="input input-promo" placeholder="Промо-код" v-model="promo" />
                  </div>
                  <div class="form__btn-wrapper">
                    <button class="form__btn" @click="sendUrProg">Записаться</button>
                    <span>Все данные защищены</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="popup popup-order is-active" v-if="requestModal === 4">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__popup-order">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" @click="$root.requestModal = 0"></button>
            <div class="content-wrapper">
              <div class="choose__box content-box" style="display:block;">
                <div class="nice-select date" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{time}}</span></div>
                <div class="nice-select subject" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{text}}</span></div>
              </div>
              <form action="/">
                <div class="form-wrapper">
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Ваше имя"  v-model="name" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Город" v-model="city"/>
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="+7" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <div class="form__btn-wrapper not_time_btn" style="margin: 15px auto;width: 300px;">
                    <button class="form__btn" style="padding: 17px;" @click="sendReg">Купить сейчас за {{this.price}} рублей</button>
                    <span>Не ждите ближайший интенсив. Решите свою проблему прямо сейчас. Купите запись эффективного вебинара, прошедшего на прошлой неделе и получите результат.</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="popup popup-thx is-active" v-if="requestModal === 5">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__popup-order">

          <div class="popup__thx">
            <button class="popup__btn popup__btn-close popup-close" @click="$root.requestModal = 0"></button>
            <div class="content-wrapper" v-html="text"></div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="popup popup-order is-active" v-if="requestModal === 6">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__popup-order">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" @click="$root.requestModal = 0"></button>
            <div class="content-wrapper">
              <div class="choose__box content-box" style="display:block;">
                <div class="nice-select__free">
                  <span>Бесплатные материалы <br/></span>
                </div>
                {{$root.requestModalText}}
              </div>
              <form action="/">
                <div class="form-wrapper">
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Ваше имя"  v-model="name" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Город" v-model="city"/>
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="+7" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <!--div class="form__promo">
                    <input autocomplete="off" type="text" name="form[]" class="input input-promo" placeholder="Промо-код" v-model="promo" />
                  </div -->
                  <div class="form__btn-wrapper">
                    <button class="form__btn" @click="sendReg">Скачать</button>
                    <span>Все данные защищены</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <section class="popup popup-order is-active" v-if="requestModal === 7">
    <div class="popup__wrapper">
      <div class="popup__inner">
        <div class="popup__popup-order">
          <div class="popup__content">
            <button class="popup__btn popup__btn-close popup-close" @click="$root.requestModal = 0"></button>
            <div class="content-wrapper">
              <div v-if="!(text)" class="choose__box content-box" style="display:block;">
                <div class="nice-select__free-title"><span>Получите консультацию и <br/>персональные условия</span></div>
                <div class="nice-select__free-subtitle"><span>Наш юрист поможет с выбором варианта решения и <br/>ответит на все вопросы о процессе обучения</span></div>
              </div>
              <div v-if="text" class="nice-select subject" style="display: block;width: 100%;margin-bottom: 10px;" tabindex="0"><span class="current">{{text}}</span></div>
              <form action="/">
                <div class="form-wrapper">
                  <div class="form__input">
                    <input autocomplete="off" type="text" name="form[]" class="input popup-input" placeholder="Ваше имя"  v-model="name" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="+7" v-model="phone" data-inputmask="'mask': '+7(999)999-99-99'" />
                  </div>
                  <div class="form__input">
                    <input autocomplete="off" type="tel" name="form[]" class="input popup-input" placeholder="E-mail" v-model="email" data-inputmask="'alias': 'email'"/>
                  </div>
                  <div class="form__btn-wrapper" style="max-width: 350px; width: initial">
                    <button v-if="!(text)" class="form__btn" @click="sendRegCloseTabs">Получить бесплатную консультацию</button>
                    <button v-if="text" style="background: #33fa14" class="form__btn" @click="subscribe">Подписаться</button>
                    <span>Нажимая на кнопку, вы принимаете условия политики и<br/>пользовательского соглашения</span>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
</template>

<script>
import axios from '@/router/http'
import Inputmask from 'inputmask'
export default {
  name: 'modals',
  props: ['user', 'text', 'id', 'time', 'price', 'requestModal'],
  data () {
    return {
      name: null,
      city: null,
      phone: null,
      email: null,
      question: null,
      timetable: [],
      promo: null
    }
  },
  created () {
  },
  mounted () {
    var self = this
    Inputmask().mask(document.querySelectorAll('input'))
    $(document).mouseup(function (e) {
      let container = $('.popup__content')
      let closeTabs = $('.popup__close')
      if (closeTabs.has(e.target).length) {
        self.$root.requestModal = 0
      }
      if (container.length) {
        if (container.has(e.target).length === 0) {
          self.$root.requestModal = 0
        }
      }
    })
  },
  methods: {
    sendQuestion () {
      if (!this.city) alert('Вам необходимо указать город')
      if (!this.question) alert('Вам необходимо задать вопрос')
      else if (!this.phone && !this.email) alert('Вам необходимо указать email или телефон')
      else {
        this.$root.outsideModal = -1
        this.$root.requestModal = 0
        var formData = new FormData()
        formData.append('crm', '10')
        formData.append('pipe', '19')
        formData.append('contact[name]', this.name)
        formData.append('contact[151]', this.phone)
        formData.append('contact[152]', this.email)
        formData.append('contact[156]', this.city)
        formData.append('contact[157]', this.user.uid)
        formData.append('lead[158]', this.city)
        formData.append('lead[159]', this.user.uid)
        formData.append('note', 'Вопрос: ' + this.question)
        axios.post('https://smart.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        )
        setTimeout(() => { alert('Спасибо, ваша заявка отправлена') }, 1)
      }
    },
    sendRegOA () {
      // НЕавтотемы
      if (!this.name) alert('Вам необходимо указать как вас зовут')
      else if (!this.city) alert('Вам необходимо указать город')
      else if (!this.phone && !this.email) alert('Вам необходимо указать email или телефон')
      else {
        this.$root.outsideModal = -1
        this.$root.requestModal = 0
        setTimeout(() => {
          let formDataSmart = new FormData()
          formDataSmart.append('crm', '15')
          formDataSmart.append('pipe', '33')
          formDataSmart.append('contact[name]', this.name)
          formDataSmart.append('contact[407]', this.phone)
          formDataSmart.append('contact[408]', this.email)
          formDataSmart.append('contact[458]', this.city)
          formDataSmart.append('contact[459]', this.user.uid)
          formDataSmart.append('lead[price]', this.price)
          formDataSmart.append('lead[452]', this.text)
          formDataSmart.append('lead[451]', this.time)
          formDataSmart.append('lead[449]', this.city)
          formDataSmart.append('lead[450]', this.user.uid)
          formDataSmart.append('lead[453]', this.promo)
          formDataSmart.append('lead[456]', this.id)
          formDataSmart.append('lead[457]', (this.$cookie.get('gcpc') ? this.$cookie.get('gcpc') : ''))
          axios.post('https://smart.v-avtoservice.com/api/import-lead',
            formDataSmart,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            else alert('Ваш заказ успешно создан, ожидайте сообщения')
          })
        }, 1)
        this.$root.requestModal = 0
      }
    },
    sendUrProg () {
      // Автотемы
      if (!this.name) alert('Вам необходимо указать как вас зовут')
      else if (!this.city) alert('Вам необходимо указать город')
      else if (!this.phone && !this.email) alert('Вам необходимо указать email или телефон')
      else {
        this.$root.outsideModal = -1
        this.$root.requestModal = 0
        setTimeout(() => {
          var formData = new FormData()
          formData.append('crm', '11')
          formData.append('pipe', '22')
          formData.append('contact[name]', this.name)
          formData.append('contact[199]', this.phone)
          formData.append('contact[200]', this.email)
          formData.append('contact[207]', this.city)
          formData.append('lead[price]', this.price)
          formData.append('lead[204]', this.city)
          formData.append('lead[214]', 'moi-uristy.ru')
          formData.append('note', 'Услуга: ' + this.text + '<br> Время: ' + this.time)

          axios.post('https://urist.v-avtoservice.com/api/import-lead',
            formData,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          )
          let formDataSmart = new FormData()
          formDataSmart.append('crm', '15')
          formDataSmart.append('pipe', '33')
          formDataSmart.append('contact[name]', this.name)
          formDataSmart.append('contact[407]', this.phone)
          formDataSmart.append('contact[408]', this.email)
          formDataSmart.append('contact[458]', this.city)
          formDataSmart.append('contact[459]', this.user.uid)
          formDataSmart.append('lead[price]', this.price)
          formDataSmart.append('lead[452]', this.text)
          formDataSmart.append('lead[451]', this.time)
          formDataSmart.append('lead[449]', this.city)
          formDataSmart.append('lead[450]', this.user.uid)
          formDataSmart.append('lead[453]', this.promo)
          formDataSmart.append('lead[456]', this.id)
          formDataSmart.append('lead[457]', (this.$cookie.get('gcpc') ? this.$cookie.get('gcpc') : ''))
          axios.post('https://smart.v-avtoservice.com/api/import-lead',
            formDataSmart,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            else alert('Ваш заказ успешно создан, ожидайте сообщения')
          })
          setTimeout(() => {
            var formData = new FormData()
            formData.append('crm', '10')
            formData.append('pipe', '18')
            formData.append('contact[name]', this.name)
            formData.append('contact[151]', this.phone)
            formData.append('contact[152]', this.email)
            formData.append('contact[156]', this.city)
            formData.append('contact[157]', this.user.uid)
            formData.append('lead[price]', this.price)
            formData.append('lead[161]', this.text)
            formData.append('lead[160]', this.time)
            formData.append('lead[158]', this.city)
            formData.append('lead[159]', this.user.uid)
            formData.append('lead[215]', this.promo)
            formData.append('lead[308]', this.id)
            formData.append('lead[339]', (this.$cookie.get('gcpc') ? this.$cookie.get('gcpc') : ''))
            axios.post('https://urist2.v-avtoservice.com/api/import-lead',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
            ).then(res => {
              if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
              else alert('Ваш заказ успешно создан, ожидайте сообщения')
              console.log(res.data.link.result.payment_link)
            })
          }, 10)
        }, 1)
        this.$root.requestModal = 0
      }
    },
    sendReg () {
      if (!this.name) alert('Вам необходимо указать как вас зовут')
      else if (!this.city) alert('Вам необходимо указать город')
      else if (!this.phone && !this.email) alert('Вам необходимо указать email или телефон')
      else {
        this.$root.outsideModal = -1
        this.$root.requestModal = 0
        var formData = new FormData()
        formData.append('crm', '15')
        formData.append('pipe', '33')
        formData.append('contact[name]', this.name)
        formData.append('contact[407]', this.phone)
        formData.append('contact[408]', this.email)
        formData.append('contact[458]', this.city)
        formData.append('contact[459]', this.user.uid)
        formData.append('lead[price]', this.price)
        formData.append('lead[452]', this.text)
        formData.append('lead[451]', this.time)
        formData.append('lead[449]', this.city)
        formData.append('lead[450]', this.user.uid)
        formData.append('lead[453]', this.promo)
        formData.append('lead[456]', this.id)
        formData.append('lead[457]', (this.$cookie.get('gcpc') ? this.$cookie.get('gcpc') : ''))
        axios.post('https://smart.v-avtoservice.com/api/import-lead',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }
        ).then(res => {
          if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
          else alert('Ваш заказ успешно создан, ожидайте сообщения')
        })
        this.$root.requestModal = 0
      }
    },
    sendRegCloseTabs () {
      if (!this.name) alert('Вам необходимо указать как вас зовут')
      else if (!this.phone && !this.email) alert('Вам необходимо указать email или телефон')
      else {
        this.$root.outsideModal = -1
        this.$root.requestModal = 0
        setTimeout(() => {
          let formDataSmart = new FormData()
          formDataSmart.append('crm', '15')
          formDataSmart.append('pipe', '33')
          formDataSmart.append('contact[name]', this.name)
          formDataSmart.append('contact[407]', this.phone)
          formDataSmart.append('contact[408]', this.email)
          formDataSmart.append('lead[452]', 'Консультация с мои-юристы')
          formDataSmart.append('note', 'Доп.информация: заявка с Закрытия вклакди <br>' + 'Закрыл вкладку на странице: ' + this.$route.name)
          formDataSmart.append('lead[457]', (this.$cookie.get('gcpc') ? this.$cookie.get('gcpc') : ''))
          axios.post('https://smart.v-avtoservice.com/api/import-lead',
            formDataSmart,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            alert('Ваша заявка отправлена, мы свяжемся с вами в ближайшее время!')
          })
        }, 1)
        this.$root.requestModal = 0
      }
    },
    subscribe () {
      if (!this.name) alert('Вам необходимо указать как вас зовут')
      else if (!this.phone && !this.email) alert('Вам необходимо указать email или телефон')
      else {
        this.$root.outsideModal = -1
        this.$root.requestModal = 0
        setTimeout(() => {
          let formDataSmart = new FormData()
          formDataSmart.append('crm', '15')
          formDataSmart.append('pipe', '33')
          formDataSmart.append('contact[name]', this.name)
          formDataSmart.append('contact[407]', this.phone)
          formDataSmart.append('contact[408]', this.email)
          // formDataSmart.append('contact[458]', 'время подписки: ' + this.text)
          formDataSmart.append('contact[459]', this.user.uid)
          formDataSmart.append('lead[price]', this.price)
          formDataSmart.append('lead[452]', this.text)
          formDataSmart.append('lead[451]', this.time)
          formDataSmart.append('lead[449]', this.city)
          formDataSmart.append('lead[450]', this.user.uid)
          formDataSmart.append('lead[453]', this.promo)
          formDataSmart.append('lead[456]', this.id)
          formDataSmart.append('lead[457]', (this.$cookie.get('gcpc') ? this.$cookie.get('gcpc') : ''))
          formDataSmart.append('note', 'Услуга: подписка<br>' + 'Тариф: ' + this.text)
          axios.post('https://smart.v-avtoservice.com/api/import-lead',
            formDataSmart,
            {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            }
          ).then(res => {
            if (res.data.link.result.payment_link) window.location.href = res.data.link.result.payment_link
            else alert('Ваш заказ успешно создан, ожидайте сообщения')
          })
        }, 1)
        this.$root.requestModal = 0
      }
    },
    hideModal () {
      this.$root.requestModal = 0
    },
    showModal (id, text, time) {
      this.$root.requestModal = id
      this.$root.requestModalText = text
      this.$root.requestModalTime = time
    }
  }
}
</script>

<style>
    #modals section {
        position: fixed;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        z-index: 99;
    }
    #modals {
        z-index: 99;
    }
    #modals .table_container {
        overflow: scroll;
        max-height: 100vh;
    }
    .nice-select::before {
      display: none;
    }
  .content-wrapper iframe {
    max-height: 60vh;max-width: 60vw;height: 60vh;
  }
    .popup__thx {
      max-width: 60vw;
    }
</style>



// WEBPACK FOOTER //
// src/components/include/modals.vue